import { render, staticRenderFns } from "./expand.vue?vue&type=template&id=31725c8c&scoped=true&"
import script from "./expand.vue?vue&type=script&lang=ts&"
export * from "./expand.vue?vue&type=script&lang=ts&"
import style0 from "./expand.vue?vue&type=style&index=0&id=31725c8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31725c8c",
  null
  
)

export default component.exports